import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'
import { Icon } from 'gipsy-ui'
import { utils, styles, translations } from 'gipsy-misc'

export default class WeekLabel extends PureComponent {
  static propTypes = {
    firstDate: PropTypes.string,
    lastDate: PropTypes.string,
    onClickLeft: PropTypes.func,
    onClickRight: PropTypes.func
  }

  makeWeekLabel = () => {
    let weekLabel = translations.calendar.thisWeek
    let today = moment()
    if (utils.datetime.isBefore(today, this.props.firstDate) || utils.datetime.isAfter(today, this.props.lastDate)) {
      weekLabel =
        utils.datetime.beautifyDate(this.props.firstDate) + ' - ' + utils.datetime.beautifyDate(this.props.lastDate)
    }
    return weekLabel
  }

  renderArrowContainer = () => {
    return (
      <div style={{ flexShrink: 0, display: 'flex' }}>
        <ArrowContainer onClick={this.props.onClickLeft}>
          <Icon icon="ArrowLeft" size={10} fill="transparent" stroke={styles.colors.darkGrey} />
        </ArrowContainer>
        <ArrowContainer onClick={this.props.onClickRight}>
          <Icon icon="ArrowRight" size={10} fill="transparent" stroke={styles.colors.darkGrey} />
        </ArrowContainer>
      </div>
    )
  }

  render() {
    return (
      <WeekviewHeader className={this.props.className}>
        <WeekviewTitle>{this.makeWeekLabel()}</WeekviewTitle>
        {this.renderArrowContainer()}
      </WeekviewHeader>
    )
  }
}

const WeekviewHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  height: 60px;
  color: ${styles.colors.textDarkColor};
  font-weight: 500;
`

const WeekviewTitle = styled.div`
  padding-bottom: 2px;
`

const ArrowContainer = styled.div`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    svg,
    g,
    path {
      stroke: ${styles.colors.primaryColor};
    }
  }
`



// WEBPACK FOOTER //
// ./src/features/weekLabel/index.js